var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7v4a1 1 0 001 1h4a1 1 0 001-1v-1h1v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h1v1H5a1 1 0 00-1 1z",
    fill: "#872AB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5H8V4h4v4h-1V5z",
    fill: "#872AB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.646 8.646l4.5-4.5.708.708-4.5 4.5-.708-.708z",
    fill: "#872AB0"
  })));
}
export default SvgIconExternalLink;